import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import AuthService from '../services/auth.service';
import NotAllowedPage from './NotAllowedPage';
import NoEmailGivenPage from './NoEmailGivenPage';
import Layout from './Home/Layout';

var authService = new AuthService();
var noEmailGivenComponent = <Layout><NoEmailGivenPage /></Layout>;
var isNotCustomerComponent = <Layout><NotAllowedPage /></Layout>;

export const PrivateRoute = ({ component: Component, ...rest }) => (
    <Route {...rest} render={props => {
        let isAuthenticated = authService.isAuthenticated() || authService.isGuest();
        let hasEmail = authService.hasLinkedEmailAccount() || authService.isUserFromExternalSSO();
        let isCustomerOrAdmin = authService.isCustomer() || authService.isAdmin();
        let isGuest = authService.isGuest();
        console.log(`PrivateRoute: isAuthenticated=${isAuthenticated}, hasEmail=${hasEmail}, isCustomerOrAdmin=${isCustomerOrAdmin}, isGuest=${isGuest}`);

        return isAuthenticated
            ? (!(isGuest || hasEmail) ? noEmailGivenComponent : (isCustomerOrAdmin || isGuest ? <Component {...props} /> : isNotCustomerComponent))
            : <Redirect to={{ pathname: '/', state: { from: props.location } }} />
    }}
    />
)


// WEBPACK FOOTER //
// ./src/components/PrivateRoute.js